import React from "react";
import cx from "classnames";
import { Checkmark } from "../icons/deprecated/Checkmark";
import { Error } from "../icons/deprecated/Error";
import "./Snackbar.scss";
export var SNACKBAR_TYPES;
(function (SNACKBAR_TYPES) {
    SNACKBAR_TYPES["INFO"] = "INFO";
    SNACKBAR_TYPES["SUCCESS"] = "SUCCESS";
    SNACKBAR_TYPES["WARNING"] = "WARNING";
    SNACKBAR_TYPES["ERROR"] = "ERROR";
})(SNACKBAR_TYPES || (SNACKBAR_TYPES = {}));
export const Snackbar = ({ type, icon = false, textAlign = "center", children, }) => {
    const classes = cx("lysa-ui-snackbar", {
        "lysa-snackbar-info": type === SNACKBAR_TYPES.INFO,
        "lysa-snackbar-success": type === SNACKBAR_TYPES.SUCCESS,
        "lysa-snackbar-warning": type === SNACKBAR_TYPES.WARNING,
        "lysa-snackbar-error": type === SNACKBAR_TYPES.ERROR,
        left: textAlign === "left",
        center: textAlign === "center",
        right: textAlign === "right",
    });
    let iconComponent = null;
    if (icon && type === SNACKBAR_TYPES.INFO) {
        iconComponent = (React.createElement("span", { className: "icon-wrapper" },
            React.createElement(Error, { size: 16, color: "#1840e3" })));
    }
    else if (icon && type === SNACKBAR_TYPES.SUCCESS) {
        iconComponent = (React.createElement("span", { className: "icon-wrapper" },
            React.createElement(Checkmark, { size: 16 })));
    }
    else if (icon && type === SNACKBAR_TYPES.WARNING) {
        iconComponent = (React.createElement("span", { className: "icon-wrapper" },
            React.createElement(Error, { size: 16, color: "#FDDE4A" })));
    }
    else if (icon && type === SNACKBAR_TYPES.ERROR) {
        iconComponent = (React.createElement("span", { className: "icon-wrapper" },
            React.createElement(Error, { size: 16 })));
    }
    return (React.createElement("div", { className: classes },
        iconComponent,
        React.createElement("div", null, children)));
};
